import { render, staticRenderFns } from "./ModalAlertIsNotAvailable.vue?vue&type=template&id=0a6eb3e6&scoped=true&"
import script from "./ModalAlertIsNotAvailable.vue?vue&type=script&lang=ts&"
export * from "./ModalAlertIsNotAvailable.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAlertIsNotAvailable.vue?vue&type=style&index=0&id=0a6eb3e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6eb3e6",
  null
  
)

export default component.exports